<div class="empty-data" [ngClass]="{ statistics: data === 'statistics' }">
  <ng-container *ngIf="data !== 'accounts'">
    <img *ngIf="!isDarkMode$" src="assets/images/dashboard/empty-data/{{ data }}.svg" alt="empty {{ data }}" />
    <img *ngIf="isDarkMode$" src="assets/images/dashboard/empty-data/{{ data }}-dark.svg" alt="empty {{ data }}" />
  </ng-container>

  <h2 *ngIf="data === 'statistics'">
    {{ 'WM_TECH_POOL.' + data.toUpperCase() + '.EMPTY_TITLE' | translate }}
  </h2>

  <p *ngIf="data !== 'accounts'">
    {{ 'WM_TECH_POOL.' + data.toUpperCase() + '.EMPTY_TEXT' | translate }}
  </p>

  <a *ngIf="data === 'statistics' || data === 'workers'" (click)="openDialog()" mat-raised-button color="pool-button-bg-primary">{{ 'WM_TECH_POOL.D.MENU.CONNECT' | translate }}</a>

  <a *ngIf="data === 'accounts'" href="{{ env.techDomain }}/support" mat-raised-button color="pool-button-bg-primary">{{ 'WM_TECH_POOL.ACCOUNT.NOT_VERIFIED.CONTACT_US' | translate }}</a>
</div>
